/**
 * スティッキースクロール機能
 * js-scroll-stage内のjs-panel要素をスクロールに応じてclipPathで表示制御
 * 横幅768px以上のみで動作
 */
export const stickys = () => {
	const stage = document.getElementById('js-scroll-stage')
	const stickyWrapper = document.getElementById('js-sticky-wrapper')
	const panels = document.querySelectorAll('.js-panel')
	const panelCount = panels.length

	if (!stage || !stickyWrapper || panelCount === 0) {
		return
	}

	// PC画面のみで動作
	const isPcScreen = window.matchMedia('(min-width: 768px)').matches
	if (!isPcScreen) {
		return
	}

	// ヘッダーの高さを取得
	const header = document.querySelector('.l-header')
	const getHeaderHeight = () => {
		return header ? header.offsetHeight : 68
	}
	const headerHeight = getHeaderHeight()

	// 初期化: 2枚目以降は上側を隠す
	// inset(上 右 下 左) -> inset(100% 0 0 0) = 上から100%隠す = 見えない
	for (let i = 1; i < panelCount; i++) {
		panels[i].style.clipPath = 'inset(100% 0 0 0)'
	}

	const handleScroll = () => {
		// PC画面でない場合は処理しない
		if (!window.matchMedia('(min-width: 768px)').matches) {
			return
		}

		const stageRect = stage.getBoundingClientRect()
		// ステージの上端位置（ヘッダー考慮）
		// ステージがヘッダーの下に来た瞬間を0地点としたい
		// getBoundingClientRect().top は画面上端からの距離
		// ヘッダーの下端に接したとき、top は headerHeight になっているはず
		const currentHeaderHeight = getHeaderHeight()
		const stageTop = stageRect.top - currentHeaderHeight

		// まだ到達していない（プラスの値）なら何もしない
		if (stageTop > 0) return

		const scrolledAmount = Math.abs(stageTop)

		// パネル1枚あたりの変化に必要なスクロール量
		// 画面の高さ（ヘッダー除く）と同じ量スクロールしたら次へ、とするのが自然
		const panelHeight = stickyWrapper.clientHeight

		panels.forEach((panel, index) => {
			// 1枚目は操作しない
			if (index === 0) return

			// アニメーション開始・終了位置の計算
			const start = (index - 1) * panelHeight

			let progress = (scrolledAmount - start) / panelHeight

			// 0〜1に丸める
			if (progress < 0) progress = 0
			if (progress > 1) progress = 1

			// 上側のマスクを減らしていく (100% -> 0%)
			const insetTop = 100 - progress * 100

			panel.style.clipPath = `inset(${insetTop}% 0 0 0)`
		})
	}

	window.addEventListener('scroll', handleScroll, { passive: true })

	// メディアクエリの変更を監視
	const mediaQuery = window.matchMedia('(min-width: 768px)')
	mediaQuery.addEventListener('change', (e) => {
		if (!e.matches) {
			// SP画面に切り替わった場合はclipPathをリセット
			for (let i = 1; i < panelCount; i++) {
				panels[i].style.clipPath = ''
			}
		} else {
			// PC画面に切り替わった場合は再初期化
			for (let i = 1; i < panelCount; i++) {
				panels[i].style.clipPath = 'inset(100% 0 0 0)'
			}
		}
	})
}
